import { Icon } from "@iconify/react";
import Dropdown from "react-bootstrap/Dropdown";
import DropdownButton from "react-bootstrap/DropdownButton";
import "./TabProduct.css";
import React from "react";
import TopRaffles from "../small/topRaffles";
import Raffleswithtimer from "../small/raffleswithtimer";
import Countdown from "react-countdown";
import Cardshowfive from "../cardsshowfive";

const TabProduct = () => {
  const tabPhysicalproducts = [
    {
      firstImg: "../../../assets/images/tabsImages/img1.png",
      profImg: "../../../assets/images/topraffle/img2.png",
      title: "Cyber Girl Smoke ",
      inStock: "8",
      price: "145.55",
      userImg: "../../../assets/images/topraffle/img3.png",
      userName: "qasim ",
    },
    {
      firstImg: "../../../assets/images/tabsImages/img2.png",
      profImg: "../../../assets/images/topraffle/img2.png",
      title: "Cyber Girl Smoke ",
      inStock: "8",
      price: "145.55",
      userImg: "../../../assets/images/topraffle/img3.png",
      userName: "Nina Hazel",
    },
    {
      firstImg: "../../../assets/images/tabsImages/img3.png",
      profImg: "../../../assets/images/topraffle/img2.png",
      title: "Cyber Girl Smoke ",
      inStock: "8",
      price: "145.55",
      userImg: "../../../assets/images/topraffle/img3.png",
      userName: "Nina Hazel",
    },
    {
      firstImg: "../../../assets/images/tabsImages/img4.png",
      profImg: "../../../assets/images/topraffle/img2.png",
      title: "Cyber Girl Smoke ",
      inStock: "8",
      price: "145.55",
      userImg: "../../../assets/images/topraffle/img3.png",
      userName: "Nina Hazel",
    },
    {
      firstImg: "../../../assets/images/tabsImages/img5.png",
      profImg: "../../../assets/images/topraffle/img2.png",
      title: "Cyber Girl Smoke ",
      inStock: "8",
      price: "145.55",
      userImg: "../../../assets/images/topraffle/img3.png",
      userName: "Nina Hazel",
    },
    {
      firstImg: "../../../assets/images/tabsImages/img6.png",
      profImg: "../../../assets/images/topraffle/img2.png",
      title: "Cyber Girl Smoke ",
      inStock: "8",
      price: "145.55",
      userImg: "../../../assets/images/topraffle/img3.png",
      userName: "Nina Hazel",
    },
    {
      firstImg: "../../../assets/images/tabsImages/img7.png",
      profImg: "../../../assets/images/topraffle/img2.png",
      title: "Cyber Girl Smoke ",
      inStock: "8",
      price: "145.55",
      userImg: "../../../assets/images/topraffle/img3.png",
      userName: "Nina Hazel",
    },
    {
      firstImg: "../../../assets/images/tabsImages/img8.png",
      profImg: "../../../assets/images/topraffle/img2.png",
      title: "Cyber Girl Smoke ",
      inStock: "8",
      price: "145.55",
      userImg: "../../../assets/images/topraffle/img3.png",
      userName: "Nina Hazel",
    },
    {
      firstImg: "../../../assets/images/tabsImages/img5.png",
      profImg: "../../../assets/images/topraffle/img2.png",
      title: "Cyber Girl Smoke ",
      inStock: "8",
      price: "145.55",
      userImg: "../../../assets/images/topraffle/img3.png",
      userName: "Nina Hazel",
    },
    {
      firstImg: "../../../assets/images/tabsImages/img6.png",
      profImg: "../../../assets/images/topraffle/img2.png",
      title: "Cyber Girl Smoke ",
      inStock: "8",
      price: "145.55",
      userImg: "../../../assets/images/topraffle/img3.png",
      userName: "Nina Hazel",
    },
  ];

  const topRaffles = [
    {
      firstImg: "../../../assets/images/topraffle/img1.png",
      profImg: "../../../assets/images/topraffle/img2.png",
      title: "Cyber Girl Smoke ",
      inStock: "8",
      price: "145.55",
      userImg: "../../../assets/images/topraffle/img3.png",
      userName: "Nina Hazel",
    },
    {
      firstImg: "../../../assets/images/topraffle/main2.png",
      profImg: "../../../assets/images/topraffle/img2.png",
      title: "Cyber Girl Smoke ",
      inStock: "8",
      price: "145.55",
      userImg: "../../../assets/images/topraffle/img3.png",
      userName: "Nina Hazel",
    },
    {
      firstImg: "../../../assets/images/topraffle/main3.png",
      profImg: "../../../assets/images/topraffle/img2.png",
      title: "Cyber Girl Smoke ",
      inStock: "8",
      price: "145.55",
      userImg: "../../../assets/images/topraffle/img3.png",
      userName: "Nina Hazel",
    },
    {
      firstImg: "../../../assets/images/topraffle/main4.png",
      profImg: "../../../assets/images/topraffle/img2.png",
      title: "Cyber Girl Smoke ",
      inStock: "8",
      price: "145.55",
      userImg: "../../../assets/images/topraffle/img3.png",
      userName: "Nina Hazel",
    },
    {
      firstImg: "../../../assets/images/topraffle/main5.png",
      profImg: "../../../assets/images/topraffle/img2.png",
      title: "Cyber Girl Smoke ",
      inStock: "8",
      price: "145.55",
      userImg: "../../../assets/images/topraffle/img3.png",
      userName: "Nina Hazel",
    },
    {
      firstImg: "../../../assets/images/topraffle/main6.png",
      profImg: "../../../assets/images/topraffle/img2.png",
      title: "Cyber Girl Smoke ",
      inStock: "8",
      price: "145.55",
      userImg: "../../../assets/images/topraffle/img3.png",
      userName: "Nina Hazel",
    },
    {
      firstImg: "../../../assets/images/topraffle/main7.png",
      profImg: "../../../assets/images/topraffle/img2.png",
      title: "Cyber Girl Smoke ",
      inStock: "8",
      price: "145.55",
      userImg: "../../../assets/images/topraffle/img3.png",
      userName: "Nina Hazel",
    },
    {
      firstImg: "../../../assets/images/topraffle/main8.png",
      profImg: "../../../assets/images/topraffle/img2.png",
      title: "Cyber Girl Smoke ",
      inStock: "8",
      price: "145.55",
      userImg: "../../../assets/images/topraffle/img3.png",
      userName: "Nina Hazel",
    },
    {
      firstImg: "../../../assets/images/topraffle/main6.png",
      profImg: "../../../assets/images/topraffle/img2.png",
      title: "Cyber Girl Smoke ",
      inStock: "8",
      price: "145.55",
      userImg: "../../../assets/images/topraffle/img3.png",
      userName: "Nina Hazel",
    },
    {
      firstImg: "../../../assets/images/topraffle/main7.png",
      profImg: "../../../assets/images/topraffle/img2.png",
      title: "Cyber Girl Smoke ",
      inStock: "8",
      price: "145.55",
      userImg: "../../../assets/images/topraffle/img3.png",
      userName: "Nina Hazel",
    },
  ];

  const renderer = ({ days, hours, minutes, seconds, completed }) => {
    return (
      <div className="countdown-items">
        <span>{days}</span> : <span>{hours}</span> : <span>{minutes}</span> :{" "}
        <span>{seconds}</span>
      </div>
    );
  };

  return (
    <div>
      <section className="tab-product">
        <div className="row">
          <div className="col-md-12">
            <ul class="nav nav-pills mb-3  bb  " id="pills-tab" role="tablist">
              <div className="left-tab d-flex ">
                <li class="nav-item" role="presentation">
                  <button
                    class="nav-link active product-tab market-product-tab"
                    id="pills-home-tab"
                    data-bs-toggle="pill"
                    data-bs-target="#pills-home"
                    type="button"
                    role="tab"
                    aria-controls="pills-home"
                    aria-selected="true"
                  >
                    <Icon
                      icon="bi:shop"
                      height={18}
                      color="white"
                      className="icon"
                    />
                    <p>Shop</p>
                  </button>
                </li>

                <li class="nav-item" role="presentation">
                  <button
                    class="nav-link market-product-tab"
                    id="pills-profile-tab"
                    data-bs-toggle="pill"
                    data-bs-target="#pills-profile"
                    type="button"
                    role="tab"
                    aria-controls="pills-profile"
                    aria-selected="false"
                  >
                    <div className="product-tab">
                      <Icon icon="carbon:money" height={18} color="white" />
                      <p>Raffles</p>
                    </div>
                  </button>
                </li>

                <li class="nav-item" role="presentation">
                  <button
                    class="nav-link market-product-tab"
                    id="pills-contact-tab"
                    data-bs-toggle="pill"
                    data-bs-target="#pills-contact"
                    type="button"
                    role="tab"
                    aria-controls="pills-contact"
                    aria-selected="false"
                  >
                    <div className="product-tab">
                      <Icon icon="ph:stack" height={18} color="white" />
                      <p>Auction</p>
                    </div>
                  </button>
                </li>

                <li class="nav-item" role="presentation">
                  <button
                    class="nav-link market-product-tab"
                    id="pills-disabled-tab"
                    data-bs-toggle="pill"
                    data-bs-target="#pills-disabled"
                    type="button"
                    role="tab"
                    aria-controls="pills-disabled"
                    aria-selected="false"
                    disabled
                  >
                    <div className="product-tab">
                      <Icon
                        icon="material-symbols:auto-activity-zone-outline"
                        height={18}
                        color="white"
                      />
                      <p>Activity</p>
                    </div>
                  </button>
                </li>
              </div>

              <div className="right-tab d-flex ">
                <li class="nav-item" role="presentation">
                  <button
                    class="nav-link market-product-tab"
                    id="pills-disabled-tab"
                    data-bs-toggle="pill"
                    data-bs-target="#pills-disabled"
                    type="button"
                    role="tab"
                    aria-controls="pills-disabled"
                    aria-selected="false"
                    disabled
                  >
                    <div className="product-tab listed">
                      <p>Recent Listed</p>
                      <Icon
                        icon="ep:arrow-up-bold"
                        rotate={2}
                        height={16}
                        color="white"
                      />
                    </div>
                  </button>
                </li>

                <li class="nav-item" role="presentation">
                  <button
                    class="nav-link market-product-tab"
                    id="pills-disabled-tab"
                    data-bs-toggle="pill"
                    data-bs-target="#pills-disabled"
                    type="button"
                    role="tab"
                    aria-controls="pills-disabled"
                    aria-selected="false"
                    disabled
                  >
                    <div className="product-tab">
                      <img src="\image\grid-icon.svg" alt="" />
                    </div>
                  </button>
                </li>
                <li class="nav-item" role="presentation">
                  <button
                    class="nav-link market-product-tab"
                    id="pills-disabled-tab"
                    data-bs-toggle="pill"
                    data-bs-target="#pills-disabled"
                    type="button"
                    role="tab"
                    aria-controls="pills-disabled"
                    aria-selected="false"
                    disabled
                  >
                    <div className="product-tabs">
                      <img src="\image\grid-foundation-icon.svg" alt="" />
                    </div>
                  </button>
                </li>
              </div>
            </ul>
            <hr />

            <div className="refresher">
              <div className="reff d-flex align-items-center">
                <div className="refreshBtn">
                  <Icon
                    icon="eos-icons:arrow-rotate"
                    height={32}
                    color="white"
                  />
                </div>
                <p>Refreshed A While Ago</p>
              </div>

              <div className="buy-bid-btn">
                <DropdownButton id="dropdown-basic-button" title="Buy">
                  <div className="buy-content">
                    <div className="buy-content-head dfb">
                      <h1>Chines Tech Girl</h1>
                      <p className="clr">Clear</p>
                    </div>
                  </div>
                  <div className="buy-img mt-2 d-flex">
                    <div className="buy-imgs">
                      <img src="\image\buynfttab.svg" alt="" />
                      <div className="closimg">
                        <Icon
                          icon="ci:off-close"
                          color="white"
                          width="16"
                          height="16"
                        />
                      </div>
                    </div>
                    <div className="etherr">
                      <p>Tech Robo #50</p>
                      <p>
                        <span>
                          <Icon
                            icon="cryptocurrency:sol"
                            color="#dfc500"
                            width="16"
                            height="16"
                            className="me-2"
                          />
                        </span>
                        143.27
                      </p>
                    </div>
                  </div>
                  <hr style={{ color: "#707070" }} />
                  <div className="bid-price">
                    <p>Total Price</p>
                    <p>
                      <span>
                        <Icon
                          icon="cryptocurrency:sol"
                          color="#dfc500"
                          width="16"
                          height="16"
                          className="me-2"
                        />
                      </span>
                      143.27
                    </p>
                  </div>
                  <div>
                    <button className="bidbuy">Buy Now</button>
                  </div>
                  <div className="bid-detail mt-2">
                    <p>
                      By Clicking “Buy now”, you agree to the Terms of Service
                    </p>
                  </div>
                </DropdownButton>

                <DropdownButton id="dropdown-basic-button" title="Bid">
                  <div className="buy-content-head dfb">
                    <h1>BULK BUY - 1</h1>
                    <p className="clr">Clear</p>
                  </div>
                  <div className="bid-price">
                    <p>Set Global Bid</p>
                  </div>
                  <hr style={{ color: "#707070" }} />

                  <div className="buy-img mt-2 d-flex">
                    <div>
                      <img src="\image\buynfttab.svg" alt="" />
                    </div>
                    <div className="etherr">
                      <p>Tech Robo #50</p>
                      <p>
                        <span>
                          <Icon
                            icon="cryptocurrency:sol"
                            color="#dfc500"
                            width="16"
                            height="16"
                            className="me-2"
                          />
                        </span>
                        143.27
                      </p>
                    </div>
                  </div>

                  <hr style={{ color: "#707070" }} />
                  <div className="bid-price">
                    <p>Offer(s) Expire In</p>
                  </div>

                  <div className="expiry-bid d-flex align-items-center justify-content-between">
                    <select id="days">
                      <option value="7 Days">7 Days</option>
                      <option value="6 Days">6 Days</option>
                      <option value="5 Days">5 Days</option>
                    </select>
                    <div className="expiry-timer">
                      <Icon
                        icon="bi:clock-history"
                        color="#707070"
                        width="16"
                        height="16"
                      />
                      <p>4:24</p>
                    </div>
                  </div>

                  <div>
                    <button className="bidbuy">Buy Now</button>
                  </div>
                  <div className="bid-detail mt-2">
                    <p>
                      By Clicking “Buy now”, you agree to the Terms of Service
                    </p>
                  </div>
                </DropdownButton>
              </div>
            </div>
            <hr style={{ color: "#707070" }} />

            {/* Tab Content */}
            {/* <h1>Tab Content</h1> */}
            <div class="tab-content" id="pills-tabContent">
              <div
                class="tab-pane fade show active"
                id="pills-home"
                role="tabpanel"
                aria-labelledby="pills-home-tab"
                tabindex="0"
              >
                <h1 className="project-tab-title">List Of Physical Items</h1>
                <Cardshowfive ArrayS={tabPhysicalproducts} />
                <h1 className="project-tab-title title2">
                  List Of Digital Items
                </h1>
                <Cardshowfive ArrayS={topRaffles} />
              </div>
              <div
                class="tab-pane fade"
                id="pills-profile"
                role="tabpanel"
                aria-labelledby="pills-profile-tab"
                tabindex="0"
              >
                <h1 className="project-tab-title">Raffles Of Physical Items</h1>
                {/*countdown cards start here   */}
                <div className="row">
                  <div className="col-sm-3">
                    <div className="countdown-wrapp">
                      <Countdown
                        renderer={renderer}
                        className="countdown"
                        date={new Date(parseInt(1672018240) * 1000)}
                      />
                    </div>

                    <div className="top-raffle-single disabled">
                      <div className="heart-love text-end">
                        <div className="icon-wrapping-hears">
                          <Icon
                            icon="ant-design:heart-filled"
                            className="heart-icon-single"
                          />
                          <span>1.2k</span>
                        </div>
                      </div>
                      <img
                        className="top-raffle-single-img"
                        src="../../../assets/images/topraffle/img1.png"
                      />
                      <div className="d-flex align-items-center top-raffle-first">
                        <img
                          className="top-raffle-prof-imgp"
                          src="../../../assets/images/topraffle/img2.png"
                        />

                        <h3 className="raffle-it">Cyber Girl Smoke</h3>
                      </div>
                      <div className="d-flex align-items-center justify-content-between top-raffle-second">
                        <h3 className="instock">
                          in stock <span>10</span>
                        </h3>
                        <div className="d-flex align-items-center justify-content-between price">
                          <h3 className="price-tit">
                            price:
                            <img
                              className="etheriumico"
                              src="../../../assets/images/topraffle/img4.png"
                            />
                            <span>150.22</span>
                          </h3>
                        </div>
                      </div>
                      <div className="forborder-bott"></div>
                      <div className="d-flex align-items-center bottom-items justify-content-between top-raffle-third">
                        <div className="d-flex align-items-center">
                          <img
                            className="top-raffle-prof-imgp"
                            src="../../../assets/images/topraffle/img3.png"
                          />

                          <h3 className="seller-name">Nina Hazel</h3>
                        </div>
                        <div>
                          <button className="place-bid">Place bid</button>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-sm-3">
                    <div className="countdown-wrapp">
                      <button className="claimbtn">Claimed</button>
                    </div>

                    <div className="top-raffle-single disabled">
                      <div className="heart-love text-end">
                        <div className="icon-wrapping-hears">
                          <Icon
                            icon="ant-design:heart-filled"
                            className="heart-icon-single"
                          />
                          <span>1.2k</span>
                        </div>
                      </div>
                      <img
                        className="top-raffle-single-img"
                        src="../../../assets/images/topraffle/img1.png"
                      />
                      <div className="d-flex align-items-center top-raffle-first">
                        <img
                          className="top-raffle-prof-imgp"
                          src="../../../assets/images/topraffle/img2.png"
                        />

                        <h3 className="raffle-it">Cyber Girl Smoke</h3>
                      </div>
                      <div className="d-flex align-items-center justify-content-between top-raffle-second">
                        <h3 className="instock">
                          in stock <span>10</span>
                        </h3>
                        <div className="d-flex align-items-center justify-content-between price">
                          <h3 className="price-tit">
                            price:
                            <img
                              className="etheriumico"
                              src="../../../assets/images/topraffle/img4.png"
                            />
                            <span>150.22</span>
                          </h3>
                        </div>
                      </div>
                      <div className="forborder-bott"></div>
                      <div className="d-flex align-items-center bottom-items justify-content-between top-raffle-third">
                        <div className="d-flex align-items-center">
                          <img
                            className="top-raffle-prof-imgp"
                            src="../../../assets/images/topraffle/img3.png"
                          />

                          <h3 className="seller-name">Nina Hazel</h3>
                        </div>
                        <div>
                          <button className="place-bid">Place bid</button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row second-row-raffles">
                  <h1 className="project-tab-title title2">
                    List Of Digital Items
                  </h1>
                </div>

                <div className="row">
                  <div className="col-sm-3">
                    <div className="countdown-wrapp">
                      <Countdown
                        renderer={renderer}
                        className="countdown"
                        date={new Date(parseInt(1672018240) * 1000)}
                      />
                    </div>

                    <div className="top-raffle-single disabled">
                      <div className="heart-love text-end">
                        <div className="icon-wrapping-hears">
                          <Icon
                            icon="ant-design:heart-filled"
                            className="heart-icon-single"
                          />
                          <span>1.2k</span>
                        </div>
                      </div>
                      <img
                        className="top-raffle-single-img"
                        src="../../../assets/images/topraffle/img1.png"
                      />
                      <div className="d-flex align-items-center top-raffle-first">
                        <img
                          className="top-raffle-prof-imgp"
                          src="../../../assets/images/topraffle/img2.png"
                        />

                        <h3 className="raffle-it">Cyber Girl Smoke</h3>
                      </div>
                      <div className="d-flex align-items-center justify-content-between top-raffle-second">
                        <h3 className="instock">
                          in stock <span>10</span>
                        </h3>
                        <div className="d-flex align-items-center justify-content-between price">
                          <h3 className="price-tit">
                            price:
                            <img
                              className="etheriumico"
                              src="../../../assets/images/topraffle/img4.png"
                            />
                            <span>150.22</span>
                          </h3>
                        </div>
                      </div>
                      <div className="forborder-bott"></div>
                      <div className="d-flex align-items-center bottom-items justify-content-between top-raffle-third">
                        <div className="d-flex align-items-center">
                          <img
                            className="top-raffle-prof-imgp"
                            src="../../../assets/images/topraffle/img3.png"
                          />

                          <h3 className="seller-name">Nina Hazel</h3>
                        </div>
                        <div>
                          <button className="place-bid">Place bid</button>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-sm-3">
                    <div className="countdown-wrapp">
                      <button className="claimbtn">Claimed</button>
                    </div>

                    <div className="top-raffle-single disabled">
                      <div className="heart-love text-end">
                        <div className="icon-wrapping-hears">
                          <Icon
                            icon="ant-design:heart-filled"
                            className="heart-icon-single"
                          />
                          <span>1.2k</span>
                        </div>
                      </div>
                      <img
                        className="top-raffle-single-img"
                        src="../../../assets/images/topraffle/img1.png"
                      />
                      <div className="d-flex align-items-center top-raffle-first">
                        <img
                          className="top-raffle-prof-imgp"
                          src="../../../assets/images/topraffle/img2.png"
                        />

                        <h3 className="raffle-it">Cyber Girl Smoke</h3>
                      </div>
                      <div className="d-flex align-items-center justify-content-between top-raffle-second">
                        <h3 className="instock">
                          in stock <span>10</span>
                        </h3>
                        <div className="d-flex align-items-center justify-content-between price">
                          <h3 className="price-tit">
                            price:
                            <img
                              className="etheriumico"
                              src="../../../assets/images/topraffle/img4.png"
                            />
                            <span>150.22</span>
                          </h3>
                        </div>
                      </div>
                      <div className="forborder-bott"></div>
                      <div className="d-flex align-items-center bottom-items justify-content-between top-raffle-third">
                        <div className="d-flex align-items-center">
                          <img
                            className="top-raffle-prof-imgp"
                            src="../../../assets/images/topraffle/img3.png"
                          />

                          <h3 className="seller-name">Nina Hazel</h3>
                        </div>
                        <div>
                          <button className="place-bid">Place bid</button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* tab 3 */}
              <div
                class="tab-pane fade"
                id="pills-contact"
                role="tabpanel"
                aria-labelledby="pills-contact-tab"
                tabindex="0"
              >
                <h1 className="project-tab-title">List Of Physical Items</h1>
                <div className="col-sm-3">
                  <div className="countdown-wrapp">
                    <div className="fire-countdown">
                      <Icon
                        icon="heroicons-solid:fire"
                        className="heart-icon-single"
                      />
                      <Countdown
                        className="countdown"
                        date={new Date(parseInt(1672018240) * 1000)}
                      />
                    </div>
                  </div>

                  <div className="top-raffle-single disabled">
                    <div className="heart-love text-end">
                      <div className="icon-wrapping-hears">
                        <Icon
                          icon="ant-design:heart-filled"
                          className="heart-icon-single"
                        />
                        <span>1.2k</span>
                      </div>
                    </div>
                    <img
                      className="top-raffle-single-img"
                      src="../../../assets/images/topraffle/img1.png"
                    />
                    <div className="d-flex align-items-center top-raffle-first">
                      <img
                        className="top-raffle-prof-imgp"
                        src="../../../assets/images/topraffle/img2.png"
                      />

                      <h3 className="raffle-it">Cyber Girl Smoke</h3>
                    </div>
                    <div className="d-flex align-items-center justify-content-between top-raffle-second">
                      <h3 className="instock">
                        in stock <span>10</span>
                      </h3>
                      <div className="d-flex align-items-center justify-content-between price">
                        <h3 className="price-tit">
                          price:
                          <img
                            className="etheriumico"
                            src="../../../assets/images/topraffle/img4.png"
                          />
                          <span>150.22</span>
                        </h3>
                      </div>
                    </div>
                    <div className="forborder-bott"></div>
                    <div className="d-flex align-items-center bottom-items justify-content-between top-raffle-third">
                      <div className="d-flex align-items-center">
                        <img
                          className="top-raffle-prof-imgp"
                          src="../../../assets/images/topraffle/img3.png"
                        />

                        <h3 className="seller-name">Nina Hazel</h3>
                      </div>
                      <div>
                        <button className="place-bid">Place bid</button>
                      </div>
                    </div>
                  </div>
                </div>
                <h1 className="project-tab-title title2">
                  List Of Digital Items
                </h1>
                <div className="col-sm-3">
                  <div className="countdown-wrapp">
                    <div className="fire-countdown">
                      <Icon
                        icon="heroicons-solid:fire"
                        className="heart-icon-single"
                      />
                      <Countdown
                        className="countdown"
                        date={new Date(parseInt(1672018240) * 1000)}
                      />
                    </div>
                  </div>

                  <div className="top-raffle-single disabled">
                    <div className="heart-love text-end">
                      <div className="icon-wrapping-hears">
                        <Icon
                          icon="ant-design:heart-filled"
                          className="heart-icon-single"
                        />
                        <span>1.2k</span>
                      </div>
                    </div>
                    <img
                      className="top-raffle-single-img"
                      src="../../../assets/images/topraffle/img1.png"
                    />
                    <div className="d-flex align-items-center top-raffle-first">
                      <img
                        className="top-raffle-prof-imgp"
                        src="../../../assets/images/topraffle/img2.png"
                      />

                      <h3 className="raffle-it">Cyber Girl Smoke</h3>
                    </div>
                    <div className="d-flex align-items-center justify-content-between top-raffle-second">
                      <h3 className="instock">
                        in stock <span>10</span>
                      </h3>
                      <div className="d-flex align-items-center justify-content-between price">
                        <h3 className="price-tit">
                          price:
                          <img
                            className="etheriumico"
                            src="../../../assets/images/topraffle/img4.png"
                          />
                          <span>150.22</span>
                        </h3>
                      </div>
                    </div>
                    <div className="forborder-bott"></div>
                    <div className="d-flex align-items-center bottom-items justify-content-between top-raffle-third">
                      <div className="d-flex align-items-center">
                        <img
                          className="top-raffle-prof-imgp"
                          src="../../../assets/images/topraffle/img3.png"
                        />

                        <h3 className="seller-name">Nina Hazel</h3>
                      </div>
                      <div>
                        <button className="place-bid">Place bid</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="tab-pane fade"
                id="pills-disabled"
                role="tabpanel"
                aria-labelledby="pills-disabled-tab"
                tabindex="0"
              >
                <h1>Tab 5</h1>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default TabProduct;
